(function () {
  function setOverlayClasses() {
    const overlays = document.querySelectorAll(".overlay");

    overlays.forEach((overlay) => {
      const text = overlay.textContent.trim();

      if (text.length < 60) {
        overlay.className = "overlay overlay-short";
      } else if (text.length < 130) {
        overlay.className = "overlay overlay-medium";
      } else if (text.length < 180) {
        overlay.className = "overlay overlay-long";
      } else {
        overlay.className = "overlay overlay-extra-long";
      }
    });
  }

  setOverlayClasses();

  const observer = new MutationObserver(setOverlayClasses);

  const gallery = document.querySelector(".mosaic-gallery");
  if (gallery) {
    observer.observe(gallery, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }
})();
